import BlScrollPickerMv from './BlScrollPickerMv.vue'

BlScrollPickerMv.install = function(Vue) {
  Vue.component(BlScrollPickerMv.name, BlScrollPickerMv)
}

export default BlScrollPickerMv
